export default __webpack_public_path__ + "static/media/9bded848-02b2-45c8-8e05-4261b905487a.e78950cb.jpg";